import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { BandejaService } from '../../services/bandeja.service';

@Component({
  selector: 'app-persona-area-autocomplete',
  templateUrl: './persona-area-autocomplete.component.html',
  styleUrls: ['./persona-area-autocomplete.component.css']
})
export class PersonaAreaAutocompleteComponent implements OnInit {

  @Input('control') control: FormControl

  @Input('label') label: string

  @Input('placeholder') placeholder: string

  //@Input('idArea') idArea: string
  @Input('idArea') idArea;
  

  @Output('onOptionSelected') onOptionSelected = new EventEmitter<any>()

  inputControl = new FormControl('')

  options: any[] = []

  data: any[] = []
  loading = false;
  optionsEmpty = false;

  optionSelected: any;

  constructor(
    private _expedienteService: BandejaService
  ) { }

  ngOnInit(): void {
    this.findData()
    this.loading = true
    this.optionsEmpty = false;

    this.control.valueChanges.subscribe(value => {
      if (!value) this.inputControl.setValue('');
    });
    this.optionsEmpty = !Boolean()
    this.loading = true
  }

  findData() {
    if (!this.idArea) return;
    
    this.inputControl.valueChanges.subscribe(value => {
      if (!value) return this.options = this.data

      this.options = this.data.filter(
        option => {
          return Boolean(option.nombreCompleto.toLowerCase().match(this.getValue(value)))
        }
      )
    })
    
    this._expedienteService.buscarPersonaPorArea(this.idArea).then((list: any) => {
      this.data = list
    })
  }

  getValue( value ) {
      if ( typeof value == 'object') return value.nombreCompleto.toLowerCase();
      if ( typeof value == 'string') return value.toLowerCase();
  }

  setOptionSelected(event) {
    this.optionSelected = (<any>event.option.value)

    this.onOptionSelected.emit(this.optionSelected)

    const { idPersona, nombreCompleto } = this.optionSelected

    this.inputControl.setValue(nombreCompleto)
    this.control.setValue(idPersona)

  }

  onFocus($event) {
    this.inputControl.setValue('')
  }

  onFocusOut($event) {
    // this.inputControl.setValue(this.optionSelected?.nombresCompletos)
  }

}
